<template>
  <footer class="Vfooter">
    <div class="footer">
      <ul>
        <li>健康游戏忠告</li>
        <li>抵制不良游戏</li>
        <li>拒绝盗版游戏</li>
        <li>注意自我保护</li>
        <li>谨防受骗上当</li>
        <li>适度游戏益脑</li>
        <li>沉迷游戏伤身</li>
        <li>合理安排时间</li>
        <li>享受健康生活</li>
      </ul>
      <div class="footer-b">
        <div class="footer-b-l">
          <a href="">
            <div class="logo"></div>
          </a>
        </div>
        <div class="footer-b-r">
          <!-- <ul class="footer-b-r-nav">
            <li class="first"><a href="https://corporate.r2game.com/?ac=about" target="_blank">关于R2</a></li>
            <li><a href="https://ch.r2games.com.cn/index.html#/game" target="_blank">魔力无线</a></li>
            <li><a href="https://corporate.r2game.com/?ac=contact" target="_blank">联系我们</a></li>
            <li><a href="https://corporate.r2game.com/join/" target="_blank">加入我们</a></li>
            <li><a href="https://corporate.r2game.com/?ac=contact" target="_blank">客服中心</a></li>
            <li><a href="https://corporate.r2game.com/?ac=contact" target="_blank">商务合作</a></li>
            <li><a href="https://ch.r2games.com.cn/terms_of_service.html" target="_blank">用户许可协议</a></li>
            <li><a href="https://ch.r2games.com.cn/terms_of_service.html" target="_blank">隐私协议</a></li>
          </ul> -->
          <p class="recommend">
            <span>推荐游戏:</span>
            <a v-html="messg"></a>
            <!--<span class="recommend-g"><a href="">{{i}}</a></span>-->
          </p>
          <p class="footer-laster">
            <!--<a>备案号：310104100000789</a>-->
            <!--<a>深B2-521054745号</a>-->
            <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备17047652号-1</a>
            <a>粤网文 [2017] 3918-769号</a>
            <!--<a>新出网证(沪)字33号</a>-->
            <a>深圳魔力数娱网络科技有限公司 ©版权所有</a>
          </p>

        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name:'Vfooter',
    data () {
      return {
        messg:''
      }
    },
    created () {
       this.$http.get(weUrl+'recommended/index.html')
        .then(function(data){
          this.messg=data.body
        },function(response){

        })
    }
  }
</script>
<style lang="stylus" scoped>
  footer
    position relative
    z-index 2
    .footer
      padding-top 40px
      >ul
        overflow hidden
        border-bottom 1px solid #e7e7e7
        padding 20px 0
        li
          color #7b7b7b
          float left
          padding 0 24px
      .footer-b
        font-size 13px
        padding 5px 0 20px 0
        overflow hidden
        .footer-b-l
          float left
          width 310px
          .logo
            float right
            margin-top 20px
            margin-right 40px
            width 168px
            height 55px
            background url("../../../static/img/icon.png")
        .footer-b-r
          width 849px
          float left
          .footer-b-r-nav
            color #c8c8c8
            overflow hidden
            padding 20px 0 5px
            margin-left -19px
            span
              color #de4205
            li
              float left
              color #000
              padding 0 19px
              border-left 1px solid #dbdbdb
              a
                color #000
                font-size 13px
                &:hover
                  color #de4205
            .first
              border none
          .recommend
            line-height 17px
            overflow hidden
            padding 25px 0 10px
            color #de4205
            span
              float left
            .recommend-g
              padding 0 10px
              a
                color #de4205
          .footer-laster
            width 800px
            line-height 23px
            a
              margin-right 10px

</style>



// WEBPACK FOOTER //
// footer.vue?aa6c160e